// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"a5ff304c","453":"98bb2bcc","678":"477543a4"}[chunkId] + ".chunk.js";
};